"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaYupConfigMenuOnline = exports.yupConfigMenuOnline = void 0;
const yup = __importStar(require("yup"));
exports.yupConfigMenuOnline = yup.object({
    lib_a_aviso: yup.boolean().required().default(true).label('Liberar Aviso para alunos'),
    lib_a_biblioteca: yup.boolean().required().default(true).label('Liberar Bliblioteca Online para alunos'),
    lib_a_boletim: yup.boolean().required().default(true).label('Liberar Boletim para alunos'),
    lib_a_conteudo: yup.boolean().required().default(true).label('Liberar Conteúdo para alunos'),
    lib_a_horarios: yup.boolean().required().default(true).label('Liberar Horários para alunos'),
    lib_a_material: yup.boolean().required().default(true).label('Liberar Material para alunos'),
    lib_a_mensagens: yup.boolean().required().default(true).label('Liberar Publicações para alunos'),
    lib_a_ocorrencias: yup.boolean().required().default(true).label('Liberar Ocorrências para alunos'),
    lib_a_perfil: yup.boolean().required().default(true).label('Liberar Perfil do Aluno para alunos'),
    lib_a_provas: yup.boolean().required().default(true).label('Liberar Provas para alunos'),
    lib_r_perfil: yup.boolean().required().default(true).label('Liberar Perfil do Aluno para responsáveis'),
    lib_r_aviso: yup.boolean().required().default(true).label('Liberar Aviso para responsáveis'),
    lib_r_biblioteca: yup.boolean().required().default(true).label('Liberar Biblioteca Online para responsáveis'),
    lib_r_boletim: yup.boolean().required().default(true).label('Liberar Boletim para responsáveis'),
    lib_r_catraca: yup.boolean().required().default(true).label('Liberar Log da Catraca para responsáveis'),
    lib_r_conteudo: yup.boolean().required().default(true).label('Liberar Conteúdo para responsáveis'),
    lib_r_docnentregue: yup.boolean().required().default(true).label('Liberar Documentos Não Entregue para responsáveis'),
    lib_r_documentos: yup.boolean().required().default(true).label('Liberar Documentos para responsáveis'),
    lib_r_fichasaude: yup.boolean().required().default(true).label('Liberar Ficha de saúde para responsáveis'),
    lib_r_financeiro: yup.boolean().required().default(true).label('Liberar Financeiro para responsáveis'),
    lib_r_horarios: yup.boolean().required().default(true).label('Liberar Horários para responsáveis'),
    lib_r_material: yup.boolean().required().default(true).label('Liberar Material para responsáveis'),
    lib_r_mensagens: yup.boolean().required().default(true).label('Liberar Publicações para responsáveis'),
    lib_r_ocorrencias: yup.boolean().required().default(true).label('Liberar Ocorrências para responsáveis'),
    lib_r_provas: yup.boolean().required().default(true).label('Liberar Provas para responsáveis'),
    lib_r_rematricula: yup.boolean().required().default(true).label('Liberar Rematrícula para responsáveis'),
    lib_r_autorizacao_transporte: yup
        .boolean()
        .required()
        .default(true)
        .label('Liberar Pessoas autorizadas para responsáveis'),
    nome_m_aviso: yup.string().required().default('Avisos').label('Nome para o menu Avisos'),
    nome_m_biblioteca: yup.string().required().default('Biblíoteca').label('Nome para o menu Biblioteca Online'),
    nome_m_boletim: yup.string().required().default('Boletim').label('Nome para o menu Boletim'),
    nome_m_catraca: yup.string().required().default('Log da Catraca').label('Nome para o menu Log da Catraca'),
    nome_m_conteudo: yup.string().required().default('Conteúdo').label('Nome para o menu Conteúdo'),
    nome_m_docnentregue: yup
        .string()
        .required()
        .default('Entrega de Documentos')
        .label('Nome para o menu Documentos Não Entregue'),
    nome_m_documentos: yup.string().required().default('Documentos').label('Nome para o menu Documentos'),
    nome_m_fichasaude: yup.string().required().default('Ficha de Saúde').label('Nome para o menu Ficha de Saúde'),
    nome_m_financeiro: yup.string().required().default('Financeiro').label('Nome para o menu Financeiros'),
    nome_m_horarios: yup.string().required().default('Horários das Aulas').label('Nome para o menu Horários'),
    nome_m_material: yup.string().required().default('Materiais').label('Nome para o menu Materiais'),
    nome_m_mensagens: yup.string().required().default('Publicações').label('Nome para o menu Publicações'),
    nome_m_ocorrencias: yup.string().required().default('Ocorrências').label('Nome para o menu Ocorrências'),
    nome_m_perfil: yup.string().required().default('Meu Perfil').label('Nome para o menu Perfil do Aluno'),
    nome_m_provas: yup.string().required().default('Provas').label('Nome para o menu Provas'),
    nome_m_rematricula: yup.string().required().default('Relatrícula').label('Nome para o menu Relatrícula'),
    nome_m_autorizacao_transporte: yup
        .string()
        .required()
        .default('Pessoas autorizadas')
        .label('Nome para o menu Pessoas autorizadas'),
});
exports.schemaYupConfigMenuOnline = exports.yupConfigMenuOnline.shape({});
